export const getUpdatedIdeaHistory = (idea, currentTab, type) => {
  switch (currentTab) {
    case 0: {
      const descriptionField = ["eureka", "contradiction"].includes(type) ? "description" : "comment";
      const nameField = ["eureka", "contradiction"].includes(type) ? "name" : "ideaName";

      return {
        tab: currentTab,
        history: {
          [descriptionField]: idea[descriptionField] || "",
          [nameField]: idea[nameField] || "",
          image: idea.image || { name: "", originalName: "", id: "" },
          imagesLibrary: idea.imagesLibrary || [],
        },
      };
    }
    case 1: {
      const customBenefits = {
        contradiction: "potentialBenefitsOfContradictionSolving",
        eureka: "potentialBenefitsOfEureka",
        multiplication: "potentialBenefitsOfMultiplication",
        subtraction: "potentialBenefitsOfSubtraction",
        replacement: "potentialBenefitsOfReplacement",
        dependency: "benefits",
      };

      return {
        tab: currentTab,
        history: {
          score: idea.score || null,
          [customBenefits[type]]: idea[customBenefits[type]] || [
            { name: "", description: "", target: [], userInfo: "" },
          ],
        },
      };
    }
    case 2: {
      return {
        tab: currentTab,
        history: {
          issues: idea.issues || [{ comment: "", description: "", createdByUser: "" }],
          issuesMessages: idea.issuesMessages || [],
          feasibleScore: idea.feasibleScore || null,
          isIdeaFeasible: idea.isIdeaFeasible || null,
        },
      };
    }
    default: {
      return {
        tab: currentTab,
        history: idea,
      };
    }
  }
};
